const API_BASE = '/api';

const api = {
  // Auth
  login: async (credentials) => {
    const response = await fetch(`${API_BASE}/auth/login.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(credentials),
    });
    return response.json();
  },

  // User Profile
  getProfile: async (userId) => {
    const response = await fetch(`${API_BASE}/user/profile.php?id=${userId}`);
    return response.json();
  },

  updateProfile: async (userId, data) => {
    const response = await fetch(`${API_BASE}/user/profile.php`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: userId, ...data }),
    });
    return response.json();
  },

  // Upload Profile Photo
  uploadProfilePhoto: async (userId, file) => {
    const formData = new FormData();
    formData.append('user_id', userId);
    formData.append('foto', file);
    
    const response = await fetch(`${API_BASE}/user/upload_foto.php`, {
      method: 'POST',
      body: formData,
    });
    return response.json();
  },

  // Books/Katalog
  getBooks: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await fetch(`${API_BASE}/buku.php?${queryString}`);
    return response.json();
  },

  getBookDetail: async (id) => {
    const response = await fetch(`${API_BASE}/buku.php?id=${id}`);
    return response.json();
  },

  searchBooks: async (query) => {
    const response = await fetch(`${API_BASE}/buku.php?search=${encodeURIComponent(query)}`);
    return response.json();
  },

  // Categories
  getCategories: async () => {
    const response = await fetch(`${API_BASE}/kategori.php`);
    return response.json();
  },

  // User Borrowings
  getMyBorrowings: async (userId) => {
    const response = await fetch(`${API_BASE}/user/peminjaman.php?user_id=${userId}`);
    return response.json();
  },

  getBorrowingDetail: async (id) => {
    const response = await fetch(`${API_BASE}/user/peminjaman.php?id=${id}`);
    return response.json();
  },

  // Request Borrow
  requestBorrow: async (data) => {
    const response = await fetch(`${API_BASE}/user/peminjaman.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    return response.json();
  },

  // Cancel Borrow (only for pending)
  cancelBorrow: async (idPeminjaman, userId) => {
    const response = await fetch(`${API_BASE}/user/peminjaman_cancel.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id_peminjaman: idPeminjaman, user_id: userId }),
    });
    return response.json();
  },

  // Dashboard Stats for User
  getUserStats: async (userId) => {
    const response = await fetch(`${API_BASE}/user/stats.php?user_id=${userId}`);
    return response.json();
  },

  // New/Popular Books
  getNewBooks: async (limit = 8) => {
    const response = await fetch(`${API_BASE}/buku.php?sort=newest&limit=${limit}`);
    return response.json();
  },

  getPopularBooks: async (limit = 8) => {
    const response = await fetch(`${API_BASE}/buku.php?sort=popular&limit=${limit}`);
    return response.json();
  },

  // ============ JURNAL API (Dosen) ============
  
  // Get all journals for user
  getJurnals: async (userId, params = {}) => {
    const queryString = new URLSearchParams({ user_id: userId, ...params }).toString();
    const response = await fetch(`${API_BASE}/user/jurnal.php?${queryString}`);
    return response.json();
  },

  // Get single journal
  getJurnal: async (userId, jurnalId) => {
    const response = await fetch(`${API_BASE}/user/jurnal.php?user_id=${userId}&id=${jurnalId}`);
    return response.json();
  },

  // Upload/Create journal
  createJurnal: async (formData) => {
    const response = await fetch(`${API_BASE}/user/jurnal.php`, {
      method: 'POST',
      body: formData, // FormData for file upload
    });
    return response.json();
  },

  // Update journal
  updateJurnal: async (data) => {
    const response = await fetch(`${API_BASE}/user/jurnal.php`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    return response.json();
  },

  // Delete journal
  deleteJurnal: async (userId, jurnalId) => {
    const response = await fetch(`${API_BASE}/user/jurnal.php`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: userId, id: jurnalId }),
    });
    return response.json();
  },

  // Search journals from external sources
  searchExternalJurnals: async (query, sumber = 'crossref', userId = null) => {
    const params = new URLSearchParams({ query, sumber });
    if (userId) params.append('user_id', userId);
    const response = await fetch(`${API_BASE}/user/jurnal_claim.php?${params}`);
    return response.json();
  },

  // Claim journal from external source
  claimJurnal: async (data) => {
    const response = await fetch(`${API_BASE}/user/jurnal_claim.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    return response.json();
  },

  // Search internal unclaimed journals (from admin database)
  searchInternalJurnals: async (dosenName, search = '') => {
    const params = new URLSearchParams();
    if (dosenName) params.append('dosen_name', dosenName);
    if (search) params.append('search', search);
    const response = await fetch(`${API_BASE}/user/jurnal_internal_claim.php?${params}`);
    return response.json();
  },

  // Claim internal journal (from admin database)
  claimInternalJurnal: async (userId, jurnalId) => {
    const response = await fetch(`${API_BASE}/user/jurnal_internal_claim.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: userId, jurnal_id: jurnalId }),
    });
    return response.json();
  },

  // ============ BUKU SAYA API (Dosen) ============
  
  // Get my books (for dosen)
  getMyBooks: async (userId, params = {}) => {
    const queryString = new URLSearchParams({ user_id: userId, ...params }).toString();
    const response = await fetch(`${API_BASE}/user/buku_saya.php?${queryString}`);
    return response.json();
  },

  // Search books for claiming
  searchBooksForClaim: async (userId, dosenName, search = '') => {
    const params = new URLSearchParams({ 
      action: 'search_claim',
      user_id: userId,
      dosen_name: dosenName 
    });
    if (search) params.append('search', search);
    const response = await fetch(`${API_BASE}/user/buku_saya.php?${params}`);
    return response.json();
  },

  // Claim a book
  claimBook: async (userId, bookId) => {
    const response = await fetch(`${API_BASE}/user/buku_saya.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'claim', user_id: userId, book_id: bookId }),
    });
    return response.json();
  },

  // Upload new book (with files)
  uploadBook: async (formData) => {
    const response = await fetch(`${API_BASE}/user/buku_saya.php`, {
      method: 'POST',
      body: formData, // FormData for file upload
    });
    return response.json();
  },

  // Update my book
  updateMyBook: async (data) => {
    const response = await fetch(`${API_BASE}/user/buku_saya.php`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    return response.json();
  },

  // Delete/Unclaim book
  deleteMyBook: async (userId, bookId) => {
    const response = await fetch(`${API_BASE}/user/buku_saya.php`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: userId, id_buku: bookId }),
    });
    return response.json();
  },

  // ============ CITATION REQUEST API (Mahasiswa) ============
  
  // Request citation from dosen's book
  requestCitation: async (data) => {
    const response = await fetch(`${API_BASE}/user/request_sitasi.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    return response.json();
  },

  // Get citation requests (for dosen to see requests)
  getCitationRequests: async (userId, params = {}) => {
    const queryString = new URLSearchParams({ user_id: userId, ...params }).toString();
    const response = await fetch(`${API_BASE}/user/request_sitasi.php?${queryString}`);
    return response.json();
  },

  // Update citation request status (dosen approve/reject)
  updateCitationRequest: async (data) => {
    const response = await fetch(`${API_BASE}/user/request_sitasi.php`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    return response.json();
  },
};

export default api;
